import { TranslatePipe } from './pipes/translate.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateService } from './services/translate.service';
import { FormatTextTranslatePipe } from './pipes/format-text-translate.pipe';

export function setupTranslateFactory(service: TranslateService) {
  return () => service.use(null!);
}
@NgModule({
  declarations: [TranslatePipe, FormatTextTranslatePipe],
  imports: [CommonModule, HttpClientModule],
  exports: [TranslatePipe, FormatTextTranslatePipe],
  providers: [TranslatePipe],
})
export class TranslateModule { }
